import React from 'react';
import styles from "./Chatbot.module.scss";
import { Button } from "@mui/material";

type ButtonMessageProp = {
    buttons: { title: string, payload: string}[];
    handleButtonClick: (button: { title: string, payload: string }) => void;
};

const ButtonMessage: React.FC<ButtonMessageProp> = ({ buttons, handleButtonClick }) => (
    <div className={styles.buttonContainer}>
        {buttons.map((button, index) => (
            <div key={`button-${index}`} className={styles.chatbox__buttons}>
                <Button
                    onClick={() => handleButtonClick(button)}
                    className={styles.chatbox__button}
                >
                    {button.title}
                </Button>
            </div>
        ))}
    </div>
);

export default ButtonMessage;